import React, { useState, useEffect } from 'react';
import { useServices } from '../../../Data/Services';
import { PageLoading } from '../../../Components/Loading';
import Icon from '../../../Components/Icons/Icon';
import { Link } from 'react-router-dom';
import { classNames, getEntityLink, useRedirect } from '../../../Services/helpers';
import NoItems from '../../../Components/EmptyStates/NoItems';
import AddService from './AddService';
import Section, {Sections} from '../../../Components/Containers/Section';

const Services = ({addServiceCallback}) => {
    const {services, addService, isSaving} = useServices(true);
    const [addingService, setAddingService] = useState(false);
    const {go, Redirect} = useRedirect();

    const handleAddService = async (type) => {
        const result = await addService(type);
        go(getEntityLink('Services/Service', result.id));
    }

    useEffect(() => {
        return addServiceCallback.listen(() => setAddingService(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>
        {services ? <Inner services={services} setAddingService={setAddingService} /> : <PageLoading />}

        <AddService {...{
            isOpen: addingService,
            setIsOpen: () => setAddingService(false),
            services,
            addService: handleAddService,
            isSaving
        }} />

        <Redirect />
    </>
}

const Inner = ({services, setAddingService}) => {
    const categories = services.reduce((categories, service) => {
        if (!categories[service.category]) {
            categories[service.category] = [];
        }
        categories[service.category].push(service);
        return categories;
    }, {});

    return <Sections>
        {Object.keys(categories).sort().map(category => {
            const services = categories[category].sort((a, b) => a.title.localeCompare(b.title));
            return <Section key={category} title={category} className="pb-6 border-b-2">
                <Category services={services} />
            </Section>
        })}
        <NoItems title="Add service" icon="Toolbox" onClick={() => setAddingService(true)} />
    </Sections>
}

const Category = ({services}) => {
    return <ul className="divide-y divide-dashed">
        {services.map(service => {
            return <li key={service.id}>
                <Link to={getEntityLink('Services/Service', service.id)} className="w-full py-3 flex">
                    <div className="grow">
                        <p>{service.title}</p>
                        <p className="mt-2">
                            <Pill title="Website" state={service.showOnWebsite} />
                            <Pill title="Quotes" state={service.showOnQuotes} />
                        </p>
                    </div>
                    <div className="flex flex-none items-center gap-x-4 shrink-0">
                        <Icon icon="RightChevron" className="mr-2" size="2x" inline />
                    </div>
                </Link>
            </li>
        })}
    </ul>
}

const Pill = ({title, state}) => {
    return <span className={classNames(
            'inline-flex items-center rounded-full px-2 py-1 mr-3 text-xs border',
            state ? 'bg-green-50 text-green-600 fill-green-600 border-green-600' : 'bg-gray-50 text-gray-600 fill-gray-600 border-gray-600'
        )}>
        <Icon icon={state ? 'Check' : 'XMark'} className="mr-2" size="1x" inline />
        {title}
    </span>
}

export default Services;
